import { ChecklistRouteConfiguration } from './config/route_configuration';
import { ChecklistConfiguration } from './config/checklist_configuration';
angular
  .module('capability-ng-checklist', [
    'ngSanitize',
    'ngAria',
    'ngMessages',
    'ngAnimate',
    'ct.ui.router.extras.core',
    'ct.ui.router.extras.dsr',
    'ct.ui.router.extras.sticky',
    'vendor'
  ])
  .config((ngChecklistRouteConfigurationProvider: ChecklistRouteConfiguration) => {
    ngChecklistRouteConfigurationProvider.state({
      'my.checklist': {
        data: {
          viewTitle: 'Checklist'
        }
      }
    });
  })
  .run((ngChecklistConfiguration: ChecklistConfiguration) => {
    ngChecklistConfiguration.configureCapability({
      checklistUrl: 'student/checklist/'
    });
  });



// WEBPACK FOOTER //
// ./app/lib/checklist/core.ts